/* Both palettes share the same component tokens and content hierarchy. */
:root[data-theme="light"] {
  color-scheme: light;
  --bg: #f7f7f7;
  --surface: #ffffff;
  --soft: #f3f3f3;
  --soft2: #eaeaea;
  --line: #e1e1e1;
  --muted: #666666;
  --text: #262626;
  --forest: #fafafa;
  --forest-light: #f0f0f0;
  --sage: #262626;
  --accent: #262626;
  --focus-ring: #525252;
  --night-ink: #ffffff;
  --night-secondary: #555555;
  --night-faint: #707070;
  --night-border-strong: #85858c;
  --night-inset: #f8f8f8;
  --night-hover: #ededed;
  --night-emphasis: #262626;
  --night-danger: #a52b2b;
  --night-success: #31734b;
  --night-warning: #775b28;
  --theme-rgb: 38 38 38;
  --theme-surface-rgb: 255 255 255;
  --theme-shell-rgb: 255 255 255;
  --theme-shell-surface: #ffffff;
  --theme-action-hover: #3f3f3f;
  --theme-selection: #dedede;
  --shadow: 0 4px 20px #17171706;
}

/* Specificity keeps these treatments stable across the production CSS chunks. */
html body[data-presentation="workspace"] .topbar {
  background: rgb(var(--theme-shell-rgb) / 0.96);
}
html body[data-presentation="workspace"] .sidebar {
  background: var(--theme-shell-surface);
}
html body[data-presentation="workspace"] .btn.black:hover {
  background: var(--theme-action-hover);
  border-color: var(--theme-action-hover);
  color: var(--night-ink);
}
html .sidebar .nav button.active {
  background: var(--soft2);
  box-shadow: inset 3px 0 0 var(--night-emphasis);
}
